import { render } from "./ViewProfesseurPage.vue?vue&type=template&id=13984c29&ts=true"
import script from "./ViewProfesseurPage.vue?vue&type=script&lang=ts"
export * from "./ViewProfesseurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__